// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` textarea {
     background-color: #282a36;
     color: #f8f8f2;
     border: 1px solid #6272a4;
     resize: none;
     font-size: 1rem;
     border-radius: 0.5rem;
     min-height: 200px;
     width: 100%;
     padding: 25px;
     box-sizing: border-box;
     height: 450px;
 }

 .InsertBoxComponent_infoText__g9QFU{
        display: block;
        margin-top: 10px;
        font-size: 0.85rem;
        color: #bbbbbb; 
        margin-left: 5px;
 }`, "",{"version":3,"sources":["webpack://./src/components/InsertBoxComponent.module.css"],"names":[],"mappings":"CAAC;KACI,yBAAyB;KACzB,cAAc;KACd,yBAAyB;KACzB,YAAY;KACZ,eAAe;KACf,qBAAqB;KACrB,iBAAiB;KACjB,WAAW;KACX,aAAa;KACb,sBAAsB;KACtB,aAAa;CACjB;;CAEA;QACO,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,gBAAgB;CACvB","sourcesContent":[" textarea {\n     background-color: #282a36;\n     color: #f8f8f2;\n     border: 1px solid #6272a4;\n     resize: none;\n     font-size: 1rem;\n     border-radius: 0.5rem;\n     min-height: 200px;\n     width: 100%;\n     padding: 25px;\n     box-sizing: border-box;\n     height: 450px;\n }\n\n .infoText{\n        display: block;\n        margin-top: 10px;\n        font-size: 0.85rem;\n        color: #bbbbbb; \n        margin-left: 5px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoText": `InsertBoxComponent_infoText__g9QFU`
};
export default ___CSS_LOADER_EXPORT___;
